import { useFetch } from './useFetch';
import type { AuxpowResponse } from '../api/types';

export function useAuxpow(btcBlockHash: string | undefined) {
  return useFetch<AuxpowResponse>(
    btcBlockHash ? `/auxpow/${btcBlockHash}` : null
  );
}
